module.exports = __webpack_public_path__ + "assets/img/5133554b5f96dca7601db1e296674fb0.png";